import AdHeader from '@/components/adHeader';
import { getGarageId, ROUTEMAP } from '@/components/fakeDoor/constants';
import { SeoPages } from '@/components/seoPages';
import Breadcrumbs from '@/components/seoPages/Breadcrumbs';
import Footer from '@/components/seoPages/Footer';
import { getEntriesCms } from '@/utils/strapi';
import { useContext, useEffect, useState } from 'react';
import { DeviceContext } from '@/pages/_app';
import { CustomerBodyStyle } from './[city]/[garageOrBrand]';
import MetaTags from '@/components/DefaultMetaTags';
import { useShowCtaAfterFold } from '@/hooks/useShowCtaAfterFold';
import { StaticExploreCta } from '@/components/staticExploreCta/StaticExploreCta';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_FAKEDOOR_LANDING } from '@/analytics/events';
import { HOSTNAME } from '@/lib/constants';
import { HOSTNAME as HOSTNAMEWITHOUTPREFIX } from '@/constants/constantsAckoDrive';
import { getHeaderString } from '@/utils/common';
import { getRewardDetailsFromCoupons } from '@/utils/rewards';
import { AUTH_KEYS, TRACKER_ID } from '@/constants/common';
import { ADSC_BOTTOM_NAV } from '@/constants/featureFlags';
import { loadGrowthbookFeatures, getFeatureValue } from '@/utils/growthbook';
import BottomNavigation from '@/components/BottomNavigation';
import { APPOINTMENT_CARD_TYPE, PAGE_TYPE } from '@/constants/enums';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectCardDetails,
    setAppointments,
} from '@/store/modules/appointmentSlice';
import {
    RewardConditions,
    FetchRewardResponseDto,
    GarageCardDetails,
    CDPData,
} from '@/types';
import {
    LOCAL_STORAGE_KEYS,
    SESSION_STORAGE_KEYS,
} from '@/constants/storageKeys';
import {
    fetchAppointmentDetailsFromOrderId,
    fetchRewardDetails,
    getUserPolicy,
    getCdpData,
    getPincodeByGarageId,
} from '@/utils/api';
import { useRouter } from 'next/router';
import Router from '@/components/common/router';
import { authenticationService } from '@/services/authentication_service';
import {
    getGarageFromPincode,
    getPincodeFromLatitudeLongitude,
} from '@/components/fakeDoor/api';
import { getGarageCardDetails } from '@/utils/garage';
import { clearPincodeAndGarageIdFromLocalStorage } from '@/utils/index';
function SeoPage(props: any) {
    console.log('CitySeoPage props ::', props);
    const router = useRouter();
    const initialPincode = props?.pincode;
    const [pincode, setPincode] = useState<string>(initialPincode);
    const [location, setLocation] = useState<{
        lat: number | null;
        lng: number | null;
    }>({ lat: null, lng: null });

    useEffect(() => {
        if (props?.garageId) {
            return;
        }

        if (props?.pincode) {
            return;
        }

        if (!props?.isLoggedInServerSide) {
            console.log('User is not logged in');
            return;
        }

        const geolocation = navigator.geolocation;
        if (!geolocation) {
            return;
        }

        if ('permissions' in navigator) {
            navigator.permissions
                .query({ name: 'geolocation' as PermissionName })
                .then((result) => {
                    if (result.state === 'granted') {
                        geolocation.getCurrentPosition(
                            (position: GeolocationPosition) => {
                                const newLocation = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };
                                setLocation(newLocation);
                                console.log('Location:', newLocation);
                            },
                            () => {
                                console.log(
                                    'Error getting geolocation permission'
                                );
                            }
                        );
                    }
                })
                .catch(() => {
                    console.error('Error getting geolocation permission');
                });
        } else {
            geolocation.getCurrentPosition(
                (position: GeolocationPosition) => {
                    const newLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    setLocation(newLocation);
                    console.log('Location:', newLocation);
                },
                () => {
                    console.log('Error getting geolocation permission');
                }
            );
        }
    }, [props?.garageId]);

    useEffect(() => {
        if (props?.garageId) {
            return;
        }

        if (location.lat !== null && location.lng !== null) {
            console.log('Location updated:', location);
            (async () => {
                const pincodeResponse = await getPincodeFromLatitudeLongitude({
                    latitude: location.lat!,
                    longitude: location.lng!,
                });
                if (
                    pincodeResponse &&
                    (pincodeResponse.garageId || pincodeResponse.garage_id)
                ) {
                    const garageId = (
                        pincodeResponse.garageId ||
                        pincodeResponse.garage_id ||
                        ''
                    ).toLowerCase();
                    if (garageId && pincodeResponse.pincode) {
                        Router.replace({
                            pathname: router.pathname,
                            query: {
                                ...router.query,
                                pincode: pincodeResponse.pincode,
                                garageId: garageId,
                            },
                        });
                        return;
                    }
                }
                if (pincodeResponse && pincodeResponse.pincode) {
                    setPincode(pincodeResponse.pincode);
                    console.log('Pincode set:', pincodeResponse.pincode);

                    if (
                        !pincodeResponse.garageId &&
                        !pincodeResponse.garage_id
                    ) {
                        const queryParams = new URLSearchParams({
                            pincode: pincodeResponse.pincode,
                        });
                        Router.replace(
                            `${ROUTEMAP.GARAGE_COMING_SOON}?${queryParams.toString()}`
                        );
                    }
                }
            })();
        }
    }, [location, pincode, props?.garageId]);
    const isMobileDevice = useContext(DeviceContext)?.isMobile;
    const showCta = useShowCtaAfterFold('CarServices');
    const cardData = useSelector(selectCardDetails) || {};
    const dispatch = useDispatch();
    const { utm_medium } = router.query;

    useEffect(() => {
        if (props?.appointmentData?.garage_id) {
            dispatch(setAppointments(props?.appointmentData));
        }
    }, []);

    useEffect(() => {
        clearPincodeAndGarageIdFromLocalStorage();
        if (utm_medium) {
            sessionStorage.setItem(
                SESSION_STORAGE_KEYS.UTM_MEDIUM,
                utm_medium as string
            );
        }
        if (
            props?.garageId &&
            !props?.isMultipleGarage &&
            !props?.appointmentData?.appointment_id
        ) {
            localStorage.setItem(
                LOCAL_STORAGE_KEYS.GARAGE_ID,
                props?.garageId as string
            );
        }
        if (props?.pincode) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.PINCODE, props.pincode);
        }
    }, [
        props.garageId,
        props.pincode,
        props.isMultipleGarage,
        props.appointmentData?.appointment_id,
    ]);

    const { isCouponAvailable, couponCode, offerDetails } =
        getRewardDetailsFromCoupons(props?.rewardDetails?.coupons);

    useEffect(() => {
        const viewPageLoadEvent = async () => {
            await viewPageAPI({
                event_name: VIEW_PAGE_FAKEDOOR_LANDING,
                customAttributes: {
                    page_type: 'near_me',
                    show_bottom_nav: props.showBottomNav,
                    is_coupon_available: isCouponAvailable,
                    coupon_code: couponCode,
                    offer_details: offerDetails,
                },
                isFakeDoor: true,
            });
        };

        viewPageLoadEvent();
    }, []);
    return (
        <>
            <MetaTags
                pathname={`near-me`}
                title={props?.garageSeoCommonsdata?.nearYouMetaTitle}
                description={
                    props?.garageSeoCommonsdata?.nearYouMetaDescription
                }
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        '@context': 'https://schema.org',
                        '@type': 'Corporation',
                        name: 'ACKO Drive',
                        url: 'https://ackodrive.com/',
                        logo: 'https://ackodrive-assets.s3.amazonaws.com/media/Ackodrive_2023_Color.png',
                        contactPoint: {
                            '@type': 'ContactPoint',
                            telephone: '18002662250',
                            contactType: 'customer service',
                            areaServed: 'IN',
                            availableLanguage: ['en', 'Hindi'],
                        },
                        sameAs: [
                            'https://www.facebook.com/ackodrive/',
                            'https://www.instagram.com/ackodrive/',
                            'https://twitter.com/ackodrive',
                        ],
                    }),
                }}
            />
            <CustomerBodyStyle isMobile={isMobileDevice} />
            <AdHeader
                hideHamburgerMenu={false}
                isMobileDevice={true}
                hideShadow={true}
            />
            {props?.garageSeoCommonsdata?.ReusableComponents?.map(
                (ReusableComponent: any, index: number) => {
                    return (
                        <section
                            id={ReusableComponent.componentName}
                            key={ReusableComponent.componentName}
                        >
                            <SeoPages
                                ReusableComponent={ReusableComponent}
                                garageSeoManualdata={props?.garageSeoManualdata}
                                garageData={props?.garageData}
                                cardData={cardData}
                                {...props}
                            />
                        </section>
                    );
                }
            )}
            <Breadcrumbs
                list={[
                    { displayName: 'Home', link: `${HOSTNAMEWITHOUTPREFIX}/` },
                    {
                        displayName: 'Service Centre',
                        link: `${HOSTNAME}`,
                    },
                ]}
            />
            {props.showBottomNav ? (
                <BottomNavigation />
            ) : (
                showCta && (
                    <StaticExploreCta
                        targetId="CarServices"
                        withHeader={true}
                    />
                )
            )}
            <Footer cities={props?.garageSeoCommonsdata?.liveCities} />
        </>
    );
}

export const getServerSideProps = async (ctx: any) => {
    const { req } = ctx || {};
    const query = ctx.query;
    let garageSeoCommonsdata: any = await getEntriesCms(
        `garage-seo-commons`,
        'live',
        'createdAt',
        999,
        '',
        '',
        '',
        true
    );

    let route = 'service-centre/near-me';
    let garageSeoManualdata: any = {};
    if (route) {
        garageSeoManualdata = await getEntriesCms(
            `garage-seo-manual-contents}`,
            'live',
            'createdAt',
            999,
            'url',
            '$eq',
            route,
            true
        );
    }

    const userId =
        getHeaderString(req.headers[AUTH_KEYS.X_USER_ID]) ||
        getHeaderString(req.headers[TRACKER_ID]);
    await loadGrowthbookFeatures(userId);
    const showBottomNav = getFeatureValue({ flagName: ADSC_BOTTOM_NAV });

    let n = [];
    let u = [...garageSeoCommonsdata?.[0]?.attributes.ReusableComponents];
    n = u.find((x) => x.componentName === 'Faq');
    let tempshowQuestions = Number(n?.showQuestions);
    if (garageSeoManualdata?.[0]?.attributes?.Faqs) {
        let tempData = garageSeoManualdata?.[0]?.attributes?.Faqs;
        n = tempData;
        let len = Math.ceil(tempData?.Faqs?.length / tempshowQuestions);
        let rdm = Math.floor(Math.random() * len);
        tempData = {
            ...tempData,
            Faqs: tempData.Faqs.splice(
                rdm * tempshowQuestions,
                tempshowQuestions
            ),
        };
        if (garageSeoManualdata?.[0]?.attributes) {
            garageSeoManualdata[0].attributes.Faqs = tempData;
        }
    }

    const currentGarageId = await getGarageId('kudlu-gate');
    let garageData: any = await getEntriesCms(
        `acko-garages`,
        'live',
        'createdAt',
        999,
        `garageId`,
        '$eq',
        `${currentGarageId}`,
        false,
        ['garageId'],
        [
            'servicing_brands',
            'servicing_brands.company_image_url',
            'garage_review_ratings',
        ]
    );
    const appointmentData = await fetchAppointmentDetailsFromOrderId(
        req,
        query?.appointmentId
    );
    const userPolicyType = await getUserPolicy(ctx.req);

    let rewardDetails: FetchRewardResponseDto | undefined;
    let cdpData: CDPData | undefined;
    let garageCardDetails: GarageCardDetails[] = [];

    let garageId = query?.garageId;
    let pincode = query?.pincode;

    //if appointmentData exists
    if (
        appointmentData &&
        appointmentData?.garage_id &&
        appointmentData?.pickup_details?.address?.pincode
    ) {
        garageId = appointmentData?.garage_id;
        pincode = appointmentData?.pickup_details?.address?.pincode;
    }

    //if garageId available and pincode not available
    if (garageId && !pincode) {
        const pincodeResponse = await getPincodeByGarageId(garageId, ctx.req);
        pincode = pincodeResponse?.pincode;
        // garageCardDetails = await getGarageCardDetails(
        //     garageId,
        //     pincode,
        //     ctx.req
        // );
    }

    if (pincode) {
        const res = await getGarageFromPincode(pincode);
        if (res?.id !== null) {
            garageId = res?.id;
            garageCardDetails = await getGarageCardDetails(
                garageId,
                pincode,
                ctx.req
            );
        }
    }

    if (garageId === undefined) {
        cdpData = await getCdpData(ctx.req);
        garageId = cdpData?.garage_id ?? undefined;
        pincode = cdpData?.pincode ?? undefined;
    }

    if (garageId !== undefined && pincode !== undefined) {
        garageCardDetails = await getGarageCardDetails(
            garageId,
            pincode,
            ctx.req
        );
    }

    const data: RewardConditions = {
        garage_id: garageId,
    };

    rewardDetails = await fetchRewardDetails(ctx.req, data);
    const isLoggedInServerSide = authenticationService.isLoggedInServerBrowser(
        ctx.req,
        ctx.res
    );

    const isMultipleGarage = garageCardDetails.length > 1;

    return {
        props: {
            garageSeoCommonsdata: garageSeoCommonsdata?.[0]?.attributes || [],
            garageSeoManualdata: garageSeoManualdata?.[0]?.attributes || {},
            garageData: garageData?.[0]?.attributes || [],
            showBottomNav: showBottomNav,
            appointmentData: appointmentData || {},
            rewardDetails: rewardDetails || {},
            garageId: garageId || null,
            isLoggedInServerSide: isLoggedInServerSide,
            userPolicyType: userPolicyType || {},
            cdpData: cdpData || {},
            garageCardDetails: garageCardDetails || [],
            pincode: pincode || null,
            isMultipleGarage: isMultipleGarage,
            pageType: PAGE_TYPE.NEAR_ME_PAGE,
        },
    };
};

export default SeoPage;
